import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=03dc6677&"
import script from "./fileDetail.vue?vue&type=script&lang=js&"
export * from "./fileDetail.vue?vue&type=script&lang=js&"
import style0 from "./fileDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports